import { ThemeProps, DefaultTheme } from 'styled-components';
import get from 'lodash/get';

export const defaultTheme = {
  colors: {
    blue: '#0077c8',
    lightBlue: '#00a9e2',
    indigo: '#6610f2',
    purple: '#6f42c1',
    pink: '#e83e8c',
    red: '#ff585d',
    orange: '#fd7e14',
    yellow: '#f4da40',
    green: '#26d07c',
    teal: '#20c997',
    cyan: '#0077c8',
    white: '#fff',
    gray: '#868e96',
    grayDark: '#343a40',
    primary: '#0077c8',
    secondary: '#868e96',
    success: '#26d07c',
    info: '#0077c8',
    warning: '#f4da40',
    danger: '#ff585d',
    light: '#ebecf0',
    dark: '#343a40',
  },
  breakpoint: {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1440px',
    xxxl: '1880px',
  },
  margin: {
    base: '2em',
  },
  padding: {
    base: '1em',
  },
  borderRadius: {
    base: '8px',
  },
  typography: {
    sansSerif: 'Rubik, sans-serif',
    monospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },
};

export const getFromTheme =
  (parameter: string) =>
  (props: ThemeProps<DefaultTheme>): string =>
    get(props, `theme.${parameter}`, '');
